<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-modal
            ref="conferenceModal"
            size="lg"
            :id="id"
            ok-title="Save"
            @ok="submit"
            @cancel="$emit('cancel')"


    >
        <b-row>
            <b-col v-bind:class="[{ busy: busy}, 'opacity-transition']">
                <pb-spinner v-if="busy"></pb-spinner>
                <b-row>
                    <b-col>
                        <b-form-group label="User: ">
                            <v-select
                                    id="user"
                                    :searchable="true"
                                    multiple
                                    v-model="localConference.userList"
                                    :clearable="false"
                                    :options="users" label="firstName">
                                <template slot="selected-option" slot-scope="option">
                                    {{ option.firstName }} {{ option.lastName }}
                                </template>
                                <template v-slot:option="option">
                                    {{ option.firstName }} {{ option.lastName }}
                                </template>
                            </v-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group label="From: ">
                            <b-row>
                                <b-col>
                                    <b-form-datepicker
                                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                            locale="de" id="from" name="from" :min="minFrom"
                                            v-validate="'required'"
                                            :state="validateState('from')"
                                            v-model="localConference.validFrom" class="mb-2 secondary"></b-form-datepicker>

                                </b-col>
                                <b-col>
                                    <b-form-timepicker v-validate="'required'"
                                                       id="localTimeFrom"
                                                       name="localTimeFrom"
                                                       :state="validateState('localTimeFrom')"
                                                       @context="(ctx) => timeFromContext = ctx"
                                                       v-model="localTimeFrom"
                                                       locale="de"></b-form-timepicker>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="To: ">
                            <b-row>
                                <b-col>
                                    <b-form-datepicker
                                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                            locale="de" id="to" name="to"
                                            v-validate="'required'"
                                            :state="validateState('to')"
                                            v-model="localConference.validTo" class="mb-2 secondary"></b-form-datepicker>
                                </b-col>
                                <b-col>
                                    <b-form-timepicker v-validate="'required'" id="localTimeTo" name="localTimeTo"
                                                       :state="validateState('localTimeTo')"
                                                       @context="(ctx) => timeToContext = ctx"
                                                       v-model="localTimeTo"
                                                       locale="de"></b-form-timepicker>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group label="Jitsi Room: ">
                            <b-form-input
                                    id="jitsi"
                                    v-validate="'required'"
                                    name="jitsi"
                                    v-model.trim="localConference.jitsiRoom"
                                    :state="validateState('jitsi')"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

    </b-modal>
</template>

<script>

    // TODO check if v-modal with props is the corrent approach, probably not

    import ConferenceApi from "../../../shared/_api/conference";
    import {mapState} from "vuex";

    export default {
        name: "conference-edit-modal",
        props: {
            conference: Object,
            id: String,
        },
        data() {
            return {
                busy: false,
                localConference: null,
                localTimeFrom: null,
                localTimeTo: null,
                timeToContext: null,
                timeFromContext: null,
                selectedUserId: null
            }
        },
        computed: {
            ...mapState('usersManagement', ['users']),
            userOptions: function () {
                return this.users.map(user => {
                    return {
                        text: user.firstName + " " + user.lastName,
                        value: user.id

                    }
                })
            },
            minFrom: function () {
                return new Date()
            },
            minTo: function () {
                return this.minFrom;
            }
        },
        methods: {
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            },
            submit(bvModalEvt) {
                bvModalEvt.preventDefault();

                this.$validator.validate().then(valid => {
                    if (valid) {
                        let validFrom = new Date(this.localConference.validFrom),
                            validTo = new Date(this.localConference.validTo);

                        validFrom.setMinutes(this.timeFromContext.minutes);
                        validFrom.setHours(this.timeFromContext.hours - validFrom.getTimezoneOffset() / 60);
                        validTo.setMinutes(this.timeToContext.minutes);
                        validTo.setHours(this.timeToContext.hours - validTo.getTimezoneOffset() / 60);

                        this.localConference.validFrom = validFrom;
                        this.localConference.validTo = validTo;
                        this.busy = true;
                        ConferenceApi.save(this.localConference).then(() => {
                            this.$nextTick(() => {
                                this.$emit('success');
                                this.$refs.conferenceModal.hide();
                            })
                        }).finally(() => {
                            this.busy = false;
                        });

                    }
                });
            }
        },
        watch: {
            conference: {
                handler: function (val) {
                    this.localConference = this.$_.cloneDeep(val);
                    if (this.localConference.validFrom) {
                        this.localTimeFrom = this.localConference.validFrom.getHours() + ':' + this.localConference.validFrom.getMinutes();
                    }
                    if (this.localConference.validTo) {
                        this.localTimeTo = this.localConference.validTo.getHours() + ':' + this.localConference.validTo.getMinutes();
                    }
                },
                deep: true,
                immediate: true
            },
            'conference.validFrom': function (val) {
                if (val && new Date(val) > new Date(this.localConference.validTo)) {
                    this.localConference.validTo = val;
                }
            }
        },
    };
</script>
